import { gql } from '@apollo/client'

export enum SortDirection {
  ASC = 'asc',
  DESC = 'desc',
}

export enum SortByColumn {
  DATE_CREATED = 'created_at',
  LAST_CLINICIAN_MESSAGE_TIME = 'last_clinician_message_time',
  LAST_PATIENT_MESSAGE_TIME = 'last_patient_message_time',
}

export enum ChatStatus {
  ACTIVE = 'ACTIVE',
  CLOSED = 'CLOSED',
}

export interface ChatsFilterRequest {
  chat_id?: string | null
  patient_first_name?: string | null
  patient_last_name?: string | null
  clinician_uuid?: string | null
  status?: ChatStatus | null
  limit?: number
  offset?: number
  sort?: SortDirection
  sort_by?: SortByColumn
}

export interface ChatData {
  chat_id: string
  patient_uuid: string
  clinician_uuid: string
  last_clinician_message_time: string
  last_patient_message_time: string
  status: ChatStatus
  created_at: string
  closed_at: string | null
  closed_by: string | null
  service_type: string
  patient_first_name: string
  patient_last_name: string
  service_name: string | null
}

export interface GetChatsResponse {
  getChats: {
    chats: ChatData[]
    limit: number
    offset: number
    total: number
    more: boolean
    sort: string
    sort_by?: string
  }
}

export const GET_CHATS = gql`
  query GetChats($filters: ChatsFilterRequest) {
    getChats(filters: $filters) {
      chats {
        chat_id
        patient_uuid
        patient_first_name
        patient_last_name
        clinician_uuid
        created_at
        closed_at
        closed_by
        service_name
        service_type
        status
        last_clinician_message_time
        last_patient_message_time
      }
      limit
      offset
      total
      more
      sort
      sort_by
    }
  }
`

export interface ConsultantSearchFilters {
  id?: string | null
  full_name?: string | null
  page?: number | null
}

export interface Consultant {
  id: string
  uuid: string
  full_name: string | null
}

export interface GetConsultantsResponse {
  getConsultants: Consultant[] | null
}

export const GET_CONSULTANTS = gql`
  query GetConsultants($filters: ConsultantSearchFilters!) {
    getConsultants(filters: $filters) {
      id
      full_name
      uuid
    }
  }
`

export interface ReassignChatClinician {
  chat_id: string
  status: string
  new_clinician_uuid: string | null
  old_clinician_uuid: string | null
}

export interface ReassignChatClinicianResponse {
  reassignChatClinician: {
    chats: ReassignChatClinician[]
  }
}

export const REASSIGN_CHAT_CLINICIAN = gql`
  mutation ReassignChatClinician($chatIds: [String!]!) {
    reassignChatClinician(chatIds: $chatIds) {
      chats {
        chat_id
        status
        new_clinician_uuid
        old_clinician_uuid
      }
    }
  }
`
